import { mapGetters } from 'vuex'

import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import { SIDE_BANNERS_SETTINGS_BY_PAGE } from '@/utils/helpers/sideBannersMovement/enums'

export default {
  mixins: [hydrationHelpers],
  data() {
    return {
      isResizeInProgress: false
    }
  },
  computed: {
    ...mapGetters({
      rectDataByDataRef: 'dom/rectDataByDataRef'
    }),
    $_sideBannerMovement_settings() {
      return SIDE_BANNERS_SETTINGS_BY_PAGE[this.$route.name]
    },
    /**
     * Checks if the second banner should be hidden.
     * We only hide the second banner if there are settings for the current page
     * and the second container height is falsy. In all other cases (e.g., no settings),
     * the second banner is expected to always be displayed.
     * @returns {boolean}
     */
    $_isSecondBannerHidden() {
      return (
        !!this.$_sideBannerMovement_settings &&
        !this.$_sideBannerMovement_containerHeights[1]
      )
    },
    $_sideBannerMovement_containerHeights() {
      if (!process.client || !this.$_sideBannerMovement_settings) return []

      const { handlers, prepareRectData } = this.$_sideBannerMovement_settings
      const rectData = prepareRectData(this.rectDataByDataRef)

      return handlers.map(handler => handler(rectData))
    }
  }
}
